/* eslint-disable max-len */
import { createIcon } from '@chakra-ui/icons';
import React from 'react';

export const DropdownChevronUp = createIcon({
    displayName: 'DropdownChevronUp',
    viewBox: '0 0 20 20',
    path: (
        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
            <path clipRule="evenodd" d="M14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L10 9.41421L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071Z" fill="#00ABE8" fillRule="evenodd" />
        </svg>
    )
});
